// extracted by mini-css-extract-plugin
module.exports = {"container":"_e8ecc5e","searchResult":"_6046114","info":"_5be309f","secondaryInfo":"_afb14fb"};